import { Drawer as DrawerPrimitive } from 'vaul';

export const DrawerPortal = DrawerPrimitive.Portal;
